'use client';

import { storyblokEditable } from '@storyblok/react';
import clsx from 'clsx';
import { Suspense, useEffect, useState } from 'react';

import { ImageClient, RichText } from '@/components/core';
import { SearchBar } from '@/layout/Layout/components/Header/components/SearchBar/SearchBar';
import { MicrocopyStoryblok, SearchSectionStoryblok } from '@/types/storyblok/storyblok-types';
import styles from './SearchSection.module.scss';

type SearchBarWrapProps = {
    blok: SearchSectionStoryblok;
    translations: MicrocopyStoryblok;
};

export const SearchBarWrap: React.FC<SearchBarWrapProps> = ({ blok, translations }) => {
    const { text, image, size } = blok;
    const height = size || 400;

    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (window?.innerWidth < 1000) {
            setIsVisible(false);
        }
    }, []);

    return (
        <div
            {...storyblokEditable(blok)}
            style={{
                height: `${height}px`,
            }}
            className={clsx(styles.root)}
        >
            <div
                style={{
                    height: '100%',
                    position: 'relative',
                }}
                className={clsx('container', styles.wrapper)}
            >
                <div className={styles.layer} />

                {isVisible && (
                    <>
                        <div className={styles.titleWrapper}>
                            <RichText
                                looksLike="h4"
                                classNameRoot={styles.rte}
                                document={text}
                            />
                        </div>

                        <Suspense fallback={<div></div>}>
                            <SearchBar
                                translations={translations}
                                className={styles.searchBar}
                            />
                        </Suspense>
                    </>
                )}

                <div className={styles.imgWrap}>
                    <ImageClient
                        src={image.filename}
                        alt={image.alt}
                        focalPoints={image.focus}
                        height={height}
                        width={1400}
                    />
                </div>
            </div>
        </div>
    );
};
